/* eslint consistent-return: 0, class-methods-use-this: 0 */
/**
 * TODO Remove this file when https://jumpcloud.atlassian.net/browse/MSP-849 and subsequent cards are implemented
 * and GitHub is not longer the source for the UI
 */
import {
  filter, includes, isEmpty, isUndefined, map, slice,
} from 'lodash';
import { uuid } from 'client/util';
import Api from 'api/v2/Api';

const githubUrl = 'https://raw.githubusercontent.com/TheJumpCloud/support/master/PowerShell/JumpCloud%20Commands%20Gallery/commands.json';
const cacheKey = 'jumpCloudCommandsCacheKey';
const cacheTTLms = 60 * 60000;

const allowedSortFields = [
  'name',
  'type',
];

class GitHubCommandsApi extends Api {
  async fetchCommands() {
    /**
     * DANGER WILL ROBINSON!
     * Fetch is used here instead of axios due to the inherited Api.js adjusting
     * too many axios defaults, resulting in a request to GitHub that gets
     * rejected.
     */
    return fetch(githubUrl, {
      method: 'GET',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
      },
    });
  }

  async getCommands(skip, limit, sort, searchTerm) {
    let results = {
      results: [],
      totalCount: 0,
    };

    const cachedData = this.getLocalCache();

    if (cachedData !== null) {
      results = cachedData;
    } else {
      const resp = await this.fetchCommands();
      const data = await resp.json();

      results.results = map(data, (cmd) => ({
        id: uuid(),
        name: cmd.name,
        type: cmd.type,
        command: cmd.command,
        commandType: cmd.type,
        link: cmd.link,
        description: cmd.description,
        source: 'JumpCloud',
      }));
      results.totalCount = results.results.length;
      this.setLocalCache(results);
    }

    // Searching only works for the command's name at this time
    if (!isEmpty(searchTerm)) {
      results.results = filter(results.results, x => x.name.toLowerCase()
        .includes(searchTerm.toLowerCase()));
    }

    // Easy skip/limit
    if (!isUndefined(skip) || !isUndefined(limit)) {
      const skipValue = isUndefined(skip) ? 0 : skip;
      const limitValue = isUndefined(limit) ? undefined : skipValue + limit;
      results.results = slice(results.results, skipValue, limitValue);
    }

    // Sort on provided field
    const sortValue = sort || 'name';
    if (!isEmpty(sortValue)) {
      // Assumption is sort is a string! (i.e., the name)
      const sortField = sortValue.replace('-', '');

      // Make sure the search term is allowed
      if (includes(allowedSortFields, sortField)) {
        // Descending check
        if (sortValue.indexOf('-') === 0) {
          results.results.sort((a, b) => b[sortField].localeCompare(a[sortField]));
        } else {
          results.results.sort((a, b) => a[sortField].localeCompare(b[sortField]));
        }
      }
    }

    results.totalCount = results.results.length;

    return results;
  }

  getLocalCache() {
    const itemStr = localStorage.getItem(cacheKey);
    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();
    const version = this.getAppVersion();

    if (version !== item.version || now.getTime() > item.expiry) {
      this.clearLocalCache();
      return null;
    }
    return item.value;
  }

  setLocalCache(data) {
    const item = {
      value: data,
      expiry: this.getCacheExpiryTime(),
      version: this.getAppVersion(), // So we can bust cache on app release
    };
    localStorage.setItem(cacheKey, JSON.stringify(item));
  }

  clearLocalCache() { return localStorage.removeItem(cacheKey); }

  getCacheExpiryTime() { return (new Date()).getTime() + cacheTTLms; }

  getAppVersion() { return process.env.VITE_VERSION || '0.0.0'; }
}

export default new GitHubCommandsApi();
